export class Non {

	public mesuresConfidentialite: string;

	constructor() { 
		 		this.mesuresConfidentialite = '';
 
	}
}
